import React, { useState, useEffect, useRef } from "react";
import { motion } from "framer-motion";
import AOS from "aos";
import "aos/dist/aos.css";
import { Helmet } from "react-helmet";
import { COLORS } from "../constants/colors";
import { containerVariants, cardVariants, fadeUp } from "../utils/variants";

const ContactUs = () => {
  const [form, setForm] = useState({
    name: "",
    email: "",
    mobile: "",
    message: "",
  });
 const [index, setIndex] = useState(0);

  const ads = [
  {
    img: "/assets/billing.jpeg",
    link: "https://softcoders.in",
  },
  {
    img: "/assets/sc.jpeg",
    link: "https://softcoders.in",
  },
  {
    img: "/assets/to1.png",
    link: "https://softcoders.in",
  },
];

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % ads.length);
    }, 4000); // 3 sec

    return () => clearInterval(interval);
  }, []);
  const formRef = useRef(null);

  useEffect(() => {
    AOS.init({ duration: 4000 });
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const { name, email, mobile, message } = form;

    const whatsappMessage = `*Contact Inquiry*\n\n*Name*: ${name}\n*Email*: ${email}\n*Mobile*: ${mobile}\n*Message*: ${message}`;
    const whatsappURL = `https://wa.me/919254147455?text=${encodeURIComponent(
      whatsappMessage
    )}`; 
    window.open(whatsappURL, "_blank");

    setForm({ name: "", email: "", mobile: "", message: "" });
  };

  const handleScrollToForm = () => {
    if (formRef.current) {
      formRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

return (
  <>
    <Helmet>
  <title>Contact Gurukul ERP | School Management Software Support</title>

  {/* ONLY ONE meta description */}
  <meta
    name="description"
    content="Contact Gurukul ERP for school management software demos, pricing, and support. Get in touch with our team for Indian schools."
  />

  <link rel="canonical" href="https://www.gurukulerp.in/contact" />

  {/* Open Graph */}
  <meta property="og:title" content="Contact Gurukul ERP | School ERP Support" />
  <meta
    property="og:description"
    content="Contact Gurukul ERP for demo, pricing and support for school management software."
  />
  <meta property="og:url" content="https://www.gurukulerp.in/contact" />
  <meta property="og:type" content="website" />

  {/* Structured Data */}
  <script type="application/ld+json">
    {JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Organization",
      name: "Gurukul ERP",
      url: "https://www.gurukulerp.in/",
      contactPoint: {
        "@type": "ContactPoint",
        contactType: "customer support",
        areaServed: "IN",
        availableLanguage: ["English", "Hindi"],
      },
    })}
  </script>
</Helmet>


    <div className="overflow-hidden">

      {/* 🔹 Hero Section */}
      <section
        className="relative h-[600px] flex items-center justify-start bg-cover bg-center px-4 sm:px-8 md:px-16 lg:px-32"
        style={{
          backgroundImage:
           "url('/assets/officepic.png')",
        }}
      >
        <div className="absolute inset-0" style={{ backgroundColor: "rgba(0,0,0,0.5)" }}></div>
        <div className="relative z-10 text-left w-full">
          <motion.h1
            variants={fadeUp}
            initial="hidden"
            animate="visible"
            className="text-4xl sm:text-5xl md:text-7xl font-bold mb-4"
            style={{ color: COLORS.white }}
          >
            Contact Us
          </motion.h1>

          <motion.p
            variants={fadeUp}
            initial="hidden"
            animate="visible"
            transition={{ delay: 0.3 }}
            className="text-lg md:text-xl mb-10 leading-relaxed"
            style={{ color: COLORS.primaryLight }}
          >
            Get in touch with us for any inquiries or support. We are here to help you.
          </motion.p>

          <motion.button
            variants={cardVariants}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={handleScrollToForm}
            className="px-7 py-4 rounded-full text-lg font-semibold shadow-lg transition-all duration-300"
            style={{
              background: `linear-gradient(to right, ${COLORS.primary}, ${COLORS.dark})`,
              color: COLORS.white,
            }}
          >
            Let's Connect
          </motion.button>
        </div>
      </section>
       {/* 🔹 Why Choose Us */}
      <motion.section
        className="py-16 w-full"
        style={{ backgroundColor: COLORS.primaryLight, color: COLORS.textSecondary}}
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
      >
        <div className="max-w-7xl mx-auto text-center mb-12 px-4 sm:px-8">
          <motion.h2 className="text-4xl font-bold mb-4" variants={fadeUp}>
            Why Choose Us?
          </motion.h2>
          <motion.p className="text-lg" variants={fadeUp}>
            Discover what makes us stand out from the competition.
          </motion.p>
        </div>
 <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto px-4">
          {[
            {
              title: "24/7 Support",
              desc: "Our team is available round the clock to ensure your operations run smoothly, no matter the time.",
            },
            {
              title: "Best Quality Service",
              desc: "We pride ourselves on delivering top-tier service, ensuring every client’s needs are met beyond expectations.",
            },
            {
              title: "Affordable Pricing",
              desc: "Quality should not come at a high cost. Our services are competitively priced to meet your budget.",
            },
          ].map((item, i) => (
            <motion.div
              key={i}
              className="p-8 rounded-lg shadow-lg"
              style={{ backgroundColor: COLORS.white, color: COLORS.textPrimary }}
              variants={cardVariants}
            >
                <h4 className="text-2xl font-bold mb-4" style={{ color: COLORS.primaryDark }}>
                {item.title}
              </h4>
              <p className="text-lg" style={{ color: COLORS.textSecondary }}>
                {item.desc}
              </p>
            </motion.div>
          ))}
        </div>
      </motion.section>
      {/* Contact Form Section */}
      <motion.section
        ref={formRef}
        className="py-16 bg-cover bg-center w-full"
        style={{
          backgroundImage:
            "url('/assets/classroom.png')",
        }}
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
      >
        <div
          className="max-w-7xl mx-auto p-8 rounded-lg shadow-lg"
          style={{ backgroundColor: "rgba(0,0,0,0.7)" }}
        >
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
            {/* Left Info */}
            {/* Left Info */}
<motion.div className="space-y-6" style={{ color: COLORS.white }} variants={fadeUp}>
  <h4 className="text-3xl font-extrabold">Contact Info</h4>
  <p className="text-lg">
    Reach out for any inquiries related to our services. We are here to assist you.
  </p>

  <div>
    <p className="font-semibold">💻 Developed by:  </p>
    <p ><strong>Shri Satya Technologies</strong></p>
    <p>Nathuram SHO Street Old, Sabzi Mandi, Subhash Chowk, Sirsa (125055), Haryana</p>
  </div>

  <div>
    <p className="font-semibold">🌐 Marketed by:</p>
     <p ><strong>Soft Coders Tech Services</strong></p>
    <p>05, B-88,Sector-2,Noida 201301(UP)</p>
  </div>

  <p className="font-semibold">📞 Phone: <a href="tel:+918295000455">+91 8295000455</a></p>
  <p className="font-semibold">📧 Mail: <a href="mailto:info@gurukulerp.in">info@gurukulerp.in</a></p>
  {/* ADS CAROUSEL */}
{/* ADS CAROUSEL */}
<div className="mt-8 justify-center font-semibold text-sm text-gray-300">
  Sponsored
</div>
<div className="mt-8 w-full max-w-lg overflow-hidden rounded-xl shadow-lg justify-center mx-auto">
  <div
    className="flex transition-transform duration-500 ease-in-out"
    style={{ transform: `translateX(-${index * 100}%)` }}
  >
     {ads.map((ad, i) => (
     <div key={i} className="min-w-full flex-shrink-0">
  <a href={ad.link} target="_blank" rel="noopener noreferrer">
    
    <div className="flex justify-center">
      <img
        src={ad.img}
        alt="Ad"
        className="w-68 h-48 object-cover rounded-xl"
      />
    </div>

  </a>
</div>
    ))}
  </div>
</div>
</motion.div>

            {/* Right Form */}
            <motion.div
              className="p-6 md:p-8 rounded-lg shadow-md"
              style={{ backgroundColor: COLORS.white }}
              variants={cardVariants}
            >
              <h4
                className="text-2xl font-semibold text-center mb-6"
                style={{ color: COLORS.primaryDark }}
              >
                Get In Touch
              </h4>
              <hr className="mb-4 border-gray-300" />

              <motion.form className="space-y-6" onSubmit={handleSubmit} variants={containerVariants}>
                {[
                  { label: "Name", name: "name", type: "text", placeholder: "Your Name" },
                  { label: "Email", name: "email", type: "email", placeholder: "Your Email" },
                  { label: "Mobile", name: "mobile", type: "number", placeholder: "Your Mobile Number" },
                ].map((input, i) => (
                  <motion.div className="flex flex-col" key={i} variants={cardVariants}>
                    <label
                      className="font-semibold mb-2 text-start"
                      style={{ color: COLORS.textSecondary }}
                    >
                      {input.label}
                    </label>
                    <input
                      type={input.type}
                      name={input.name}
                      value={form[input.name]}
                      onChange={handleChange}
                      placeholder={input.placeholder}
                      required
                      className="p-4 rounded-md border focus:outline-none focus:ring-2 transition duration-300"
                      style={{
                        borderColor: COLORS.medium,
                        color: COLORS.textPrimary,
                        focusRingColor: COLORS.primary,
                      }}
                    />
                  </motion.div>
                ))}

                {/* Message */}
                <motion.div className="flex flex-col" variants={cardVariants}>
                  <label
                    className="font-semibold mb-2 text-start"
                    style={{ color: COLORS.textSecondary }}
                  >
                    Message
                  </label>
                  <textarea
                    name="message"
                    value={form.message}
                    onChange={handleChange}
                    placeholder="Your Message"
                    rows="5"
                    required
                    className="p-4 rounded-md border focus:outline-none focus:ring-2 transition duration-300"
                    style={{
                      borderColor: COLORS.medium,
                      color: COLORS.textPrimary,
                    }}
                  />
                </motion.div>

                <motion.button
                  type="submit"
                  variants={cardVariants}
                  className="w-full py-3 rounded-md font-semibold transition duration-300"
                  style={{
                    background: `linear-gradient(to right, ${COLORS.primary}, ${COLORS.secondary})`,
                    color: COLORS.white,
                  }}
                >
                  Send via WhatsApp
                </motion.button>
              </motion.form>
            </motion.div>
          </div>
        </div>
      </motion.section>
    </div>
    </>
  );
};

export default ContactUs;
